function getStyle(obj, sName) {
  //return obj.currentStyle[sName] || getComputedStyle(obj,false)[sName]  ;
  if (!obj) {
    return 0;
  }
  return parseFloat(
    (obj.currentStyle
      ? obj.currentStyle[sName]
      : getComputedStyle(obj, false)[sName]
    ).replace("px", "")
  );
}
let format = value => {
  return value >= 10 ? value : "0" + value;
};
export default {
  // 获取table的高度信息
  getTableHeight() {
    const big_div = document.querySelector(".content-center-child"); // 整个区域
    const content_header = document.querySelector(".content--header--show"); // 获取页面头部
    const content_operation = document.querySelector(".content--operation"); // 获取操作区域
    const content_page_div = document.querySelector(".content-page-div"); // 分页区域

    const big_div_height = getStyle(big_div, "height");
    const content_header_height = getStyle(content_header, "height");
    const content_operation_height = getStyle(content_operation, "height");
    const content_page_div_height = getStyle(content_page_div, "height");

    const tb =
      big_div_height -
      (content_header_height +
        content_operation_height +
        content_page_div_height +
        30);

    return tb;
  },
  getTableWidth() {
    const big_div = document.querySelector(".content-center-child").offsetWidth;
    return big_div - 100;
  },
  convertToDatetimeFromTimespan(timespan) {
    let date = new Date(timespan);
    return date;
  },
  convertToDatetime(time, type) {
    let result;
    if (time === "") {
      return (result = "");
    }
    let date = new Date(time);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let second = date.getSeconds();
    switch (type) {
      case 0: // 01-05
        result = `${format(month)}-${format(day)}`;
        break;
      case 1: // 11:12
        result = `${format(hours)}-${format(minutes)}`;
        break;
      case 2: // 2015-01-05
        result = `${year}-${format(month)}-${format(day)}`;
        break;
      case 3: // 2015-01-05 11:12
        result = `${year}-${format(month)}-${format(day)}  ${format(
          hours
        )}:${format(minutes)}`;
        break;
      case 4: // 2015-01-05 11:12:06
        result = `${year}-${format(month)}-${format(day)} ${format(
          hours
        )}:${format(minutes)}:${format(second)}`;
        break;
    }
    return result;
  },
  getDataJiedduan(type) {
    let startTime, endTime;
    let now = new Date(); //当前日期
    var nowDayOfWeek = now.getDay(); //今天本周的第几天
    var nowDay = now.getDate(); //当前日
    let nowMonth = now.getMonth(); //当前月
    let nowYear = now.getFullYear(); //当前年
    let jd = Math.ceil((nowMonth + 1) / 3);
    switch (type) {
      case "本周":
        startTime = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek);
        endTime = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek));
      case "本月":
        startTime = new Date(nowYear, nowMonth, 1);
        endTime = new Date(nowYear, nowMonth + 1, 0);
        break;
      case "本季度":
        startTime = new Date(nowYear, (jd - 1) * 3, 1);
        endTime = new Date(nowYear, jd * 3, 0);
        break;
      case "本年":
        startTime = new Date(nowYear, 0, 1);
        endTime = new Date(nowYear, 11, 31);
        break;
      case "本年-上半年":
        startTime = new Date(nowYear, 0, 1);
        endTime = new Date(nowYear, 5, 30);
        break;
      case "本年-下半年":
        startTime = new Date(nowYear, 6, 1);
        endTime = new Date(nowYear, 11, 31);
        break;
    }
    return [startTime, endTime];
  },
  //判断浏览器类型
  browser() {
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    var isOpera = userAgent.indexOf("OPR") > -1;
    if (isOpera) {
      return "Opera";
    }
    //判断是否Opera浏览器 OPR/43.0.2442.991

    //if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) { return "IE"; }; //判断是否IE浏览器

    if (userAgent.indexOf("Firefox") > -1) {
      return "FF";
    } //判断是否Firefox浏览器  Firefox/51.0
    if (userAgent.indexOf("Trident") > -1) {
      return "IE";
    } //判断是否IE浏览器  Trident/7.0; rv:11.0
    if (userAgent.indexOf("Edge") > -1) {
      return "Edge";
    } //判断是否Edge浏览器  Edge/14.14393
    if (userAgent.indexOf("Chrome") > -1) {
      return "Chrome";
    } // Chrome/56.0.2924.87
    if (userAgent.indexOf("Safari") > -1) {
      return "Safari";
    } //判断是否Safari浏览器 AppleWebKit/534.57.2 Version/5.1.7 Safari/534.57.2
  }
};
export const changeCSS = (element, className) => {
  if (!element || !className) return;
  element.className = className;
};

/**
 * @desc 检测滚动容器是否滚动到底部
 * @param {HTMLElement} ele
 * @returns {Boolean}
 */
export const checkReachBottom = ele => {
  const scrollHeight = ele.scrollHeight;
  const scrollTop = ele.scrollTop;
  const offsetHeight = ele.offsetHeight;
  return !!(scrollTop + offsetHeight >= scrollHeight);
};

/**
 * @desc 函数节流
 * @param {Function} cb 回调函数
 * @param {Number} delay 延迟时间
 * @returns {Function}
 */
export const throttle = (cb, delay = 300) => {
  let prev = 0;
  return function(...args) {
    const context = this;
    const now = +new Date();
    if (now - prev > delay) {
      cb && cb.apply(context, args);
      prev = now;
    }
  };
};

/**
 * @desc 函数防抖
 * @param {Function} cb 回调函数
 * @param {Number} delay 延迟时间
 * @returns {Function}
 */
export const debounce = (cb, delay = 300) => {
  let timer = null;
  return function(...args) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      cb && cb.apply(this, args);
    }, delay);
  };
};

/**
 * @desc 获取url参数
 * @param {String} name
 * @returns {String}
 */
export const getQueryString = name => {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, "i");
  const r = window.location.search.substr(1).match(reg);
  if (r !== null) return decodeURIComponent(r[2]);
  return null;
};

/**
 * @desc dom元素到页面顶部的距离
 * @param {HTMLElement} ele
 * @returns {Object}
 */
export const getPos = ele => {
  let left = 0;
  let top = 0;
  while (ele) {
    left += ele.offsetLeft;
    top += ele.offsetTop;
    ele = ele.offsetParent;
  }
  return {
    left,
    top
  };
};

/**
 * @desc 弧度转角度
 * @param {Number} n
 * @returns {Number}
 */
export const a2d = n => {
  return (n * 180) / Math.PI;
};

/**
 * @desc 角度转弧度
 * @param {Number} n
 * @returns {Number}
 */
export const d2a = n => {
  return (n * Math.PI) / 180;
};
